import { fetchLogin } from "@actions";
import { hideSuccessAlert } from "@actions/modals";
import AuthenticationClient from "@common/api/AuthenticationClient";
import LoginAction from "@common/redux/actions/LoginAction";
import axios from "@common/api/desktop/axios";
import ModalContainer from "@modals/ModalContainer";
import { detect } from "detect-browser";
import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Form,
  Grid,
  Header,
  Input,
  Label,
  Message,
} from "semantic-ui-react";
import { epochInSeconds } from "@common/components/helpers/datetime";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logIn: {},
      loading: false,
      showReset: false,
      loggedIn: false,
      userName: "",
      password: "",
      activeIndex: 0,
      panes: [],
      passwordMatch: true,
      newPasswordRepeat: "",
      newPassword: "",
      userEmail: "",
      forgotPassword: false,
      logInFail: false,
      expired: false,
      browser: detect(),
    };
  }

  login = () => {
    const onError = (error) => {
      this.setState({
        loginFail: true,
        loading: false,
        showReset: error.optionShowResetPassword || false,
      });
    };
    this.setState({ loading: true, expired: false }, () => {
      this.props
        .fetchLogin(this.state.userName, this.state.password)
        .then(() => {
          if (this.props.logIn.resetPassword) {
            this.props.history.push("/reset");
          } else {
            const hasCompliancePermission = this.props.logIn.menu
              .map((item) => item.code)
              .includes("COMPLIANCE_MENU");

            const callback = () => {
              const { complianceOnly } = this.props.logIn;
              LoginAction.dispatch({
                isDesktop: true,
                optionShowComplianceAlerts: !complianceOnly,
                optionDisplaySessionsInCompliance: !complianceOnly,
              });
              sessionStorage.setItem("login", JSON.stringify(this.props.logIn));
              this.props.hideSuccessAlert().then(() => {
                this.props.history.push("/dashboard");
              });
            };
            if (!hasCompliancePermission) {
              callback();
              return;
            }

            AuthenticationClient.SignIn(
              this.state.userName,
              this.state.password,
            ).then(({ accessToken, refreshToken, expiresIn }) => {
              sessionStorage.setItem("accessToken", accessToken);
              sessionStorage.setItem("refreshToken", refreshToken);
              sessionStorage.setItem(
                "tokenExpires",
                epochInSeconds() + expiresIn,
              );
              callback();
            }, onError);
          }
        }, onError);
    });
  };

  handleChange = (event, { name, value }) => {
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  };

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const expired = query.get("expired");
    this.setState({ expired: expired !== null });

    // const { logIn } = this.props;
    // if (logIn) {
    //   this.props.history.push("/dashboard");
    // }
  }

  render() {
    if (this.state.browser.name === "ie") {
      return (
        <Grid centered className="h-100">
          <Grid.Row>
            <Grid.Column width="6" textAlign="center" verticalAlign="middle">
              <img src="logo.png" alt="Rimini Logo" id="logo" />
              <Header as="h2" color="blue">
                Browser Not Supported
              </Header>
              <p>
                Unfortunately, Internet Explorer is not compatible with Rimini
                Portal.
              </p>
              <p>
                Please try another browser such as <b>Chrome</b>, <b>Firefox</b>{" "}
                or <b>Edge</b>.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }

    return (
      <Grid centered className="h-100">
        <Grid.Row>
          <Grid.Column
            widescreen="7"
            computer="9"
            largeScreen="8"
            tablet="12"
            verticalAlign="middle"
            textAlign="center"
          >
            {axios.defaults.baseURL ===
              "https://gneval-api.guardian-cms.com/api" && (
              <Label color="green">Evaluation Version</Label>
            )}

            <img
              src="logo.png"
              alt="Rimini Logo"
              id="logo"
              className="m-auto mb-3"
            />
            <Form id="login" className="mt-3">
              {this.state.loginFail && (
                <Message negative>
                  <Message.Header>Login Failed</Message.Header>
                  <p>Please check your username and password.</p>

                  {this.state.showReset && (
                    <Button
                      negative
                      onClick={() => this.props.history.push("/forgotten")}
                    >
                      Reset Password
                    </Button>
                  )}
                </Message>
              )}
              {this.state.expired && (
                <Message negative>
                  <Message.Header>Session Expired</Message.Header> Your login
                  session has expired, please login again.
                </Message>
              )}
              <Form.Field>
                <Input
                  icon="user"
                  iconPosition="left"
                  placeholder="Username"
                  name="userName"
                  onChange={this.handleChange}
                  value={this.state.userName}
                />
              </Form.Field>
              <Form.Field>
                <Input
                  icon="lock"
                  iconPosition="left"
                  placeholder="Password"
                  name="password"
                  onChange={this.handleChange}
                  value={this.state.password}
                  type="password"
                />
              </Form.Field>
              <Button
                fluid
                disabled={
                  this.state.loading ||
                  this.state.userName.length < 1 ||
                  this.state.password.length < 1
                }
                loading={this.state.loading}
                primary
                onClick={this.login}
                size="large"
              >
                Log In
              </Button>
            </Form>
            <ModalContainer />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, {
  fetchLogin,
  hideSuccessAlert,
})(Login);
